import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.size.sm
  },
  names: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
